// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* 引入vuejs */
import Vue from 'vue'
/* 引入组件App */
import App from './App'
/* 引入路由配置 */
import router from './router'
/* 引入element-ui */
import ElementUI from 'element-ui'
/* 按需引入vant，移动端使用 */
import './vant'

import '@/theme/green/index.css'
// import 'element-ui/lib/theme-chalk/index.css'
/* 引入normalize.css */
import 'normalize.css/normalize.css'
/* 引入vuex */
import store from './store'
/* 引入NProgress */
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 可选：自定义样式（覆盖默认）
NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500,     // 递增进度条的速度
  showSpinner: false, // 是否显示加载 spinner
  trickleSpeed: 200,  // 自动递增间隔
  minimum: 0.3        // 最小百分比
})

/* 引入IconSvg(iconfont) */
import '@/assets/iconfont/iconfont'
import IconSvg from '@/components/Icon-svg/index.vue'
import '@/icon-font/iconfont.css'
/* 引入Mock */
// import Mock from './mock'

import ba from 'vue-ba'

import 'viewerjs/dist/viewer.css'
import Viewer, {api as viewerApi} from 'v-viewer'

import vueTouch from 'vue-plugin-touch'

import HeaderSort from '@/components/jx/HeaderSort'
import orangeMode from '@/utils/orangeMode'
Vue.prototype.orangeMode = orangeMode
import {isWxWork, locationReplace} from './utils/util'
import {netLogEvent} from './utils/util'
/* 引入VueClipboard */
import VueClipboard from 'vue-clipboard2'
import permission from '@/directives/permission'
// 注册全局指令
Vue.directive('permission', permission)
import BaseImage from '@/components/jx/BaseImage.vue'

// import '@/utils/windowProxy'

Vue.component('BaseImage', BaseImage)
Vue.use(VueClipboard)

Vue.use(vueTouch)
Vue.use(Viewer)
Viewer.setDefaults({
  zIndexInline: 2017
})
router.onError((error) => {
  console.log('路由加载错误', error)
  // 一般是路由组件包加载失败，重新刷新下页面
  // location.reload()
})
// Mock.init()
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.component('icon-svg', IconSvg)
Vue.component('HeaderSort',HeaderSort)
Vue.use(ba, process.env.VUE_APP_BAIDU_ID)
Vue.use(ba, { siteId: process.env.VUE_APP_BAIDU_ID })

// 日志上报
Vue.prototype.netLogEvent = netLogEvent

// 引入lodash工具函数
import lodashUtils from '@/utils/lodashUtil'
Vue.prototype.$lodashUtils = lodashUtils


/* eslint-disable no-new */
const whiteList = ['/teaching/simulation', '/other/', '/mobile/', '/404', '/403', '/auditComposition']

// 页面埋点
const pageLog = (to, from) => {
  const pages = ['考试分析']
  if (pages.includes(to.name)) { // 进入页面埋点
    
    netLogEvent('timingStart','pageLog',`【${to.name}】停留时长`, {
      page: to.name,
      roles: JSON.stringify(store.getters.roles)
    });
  }
  if (pages.includes(from.name)) { // 离开页面
    netLogEvent('timingEnd', 'pageLog', `【${from.name}】停留时长`, {
      page: from.name,
      roles: JSON.stringify(store.getters.roles)
    });
  }
}
const checkPermission = (pathPermission, userRoles) => {
  // console.log('checkPermission', pathPermission, userRoles)
  if (!pathPermission) {
    return true
  }
  const {business, roles} = pathPermission
  if (!roles || !roles.length) { // 未配置roles或者roles为空都默认有权限
    return true
  }
  let hasPermission = roles.some(role => {

    return userRoles.includes(role)
  })

  return hasPermission

}

router.beforeEach((to, from, next) => {
  try {
    pageLog(to, from)
    
  } catch (error) {
  }

  NProgress.start()
  console.log('路由', to, from)
 
  if (to.path.indexOf('/other') > -1) {
    next()
  } else {

    if (isWxWork() && !to.meta.isMobile) {
      // let mobileUrl = `${location.origin}/#/mobile`
      // locationReplace(mobileUrl)
      // 企微问题， 如果从任务列表返回，并且返回的非移动端页面则关闭页面
      if (from && from.name === 'taskList') {
        if (WeixinJSBridge) {
          document.addEventListener("WeixinJSBridgeReady", function() {
            WeixinJSBridge.call("closeWindow")
          }, false)
          WeixinJSBridge.call('closeWindow')
        } else {
          // 关闭窗口
          window.opener = null
          window.open('', '_self')
          window.close()
  
        }
      }
      next({
        path: '/mobile',
        replace: true
      })
      
    }

    if (whiteList.some(path => to.path === path || to.path.startsWith(path.replace('^', '')))) {
      next()
    } else {
      
      store.dispatch('GetInfo').then(res => {
        const {roles} = res
        const teacherRoleIds = store.getters.teacherRoleIds
        if (to.path === '/' || to.path === '/preparing/navigation') {
          const hasTargetRole = teacherRoleIds.some(id => id === '1' || id === '2')
          if (hasTargetRole) {
            next({ path: '/workbench/home', replace: true })
            return
          }
        }
        const key = window.location.hostname + ':ees:page';
        let page = sessionStorage.getItem(key)
        if (page == 'h5' && !from.meta.isMobile) {
          //sessionStorage.removeItem(key)
          next({
            path: '/mobile',
            replace: true
          })
          
        } else {

          const {meta: {permission}} = to

          let hasPermission = checkPermission(permission, roles)
          if (hasPermission) {
            next()
          } else {
            next({
              path: '/403'
            })
          }
        }
      })


    }
 
  }
  let title = to.meta.title || to.name
  document.title = title ? `${title}-E教学` : 'E教学'

})
router.afterEach(() => {
  NProgress.done()
})

import {$_Qt_fullScreen_fix} from './utils/common'
import {$MathJax} from './utils/util'
Vue.prototype.$_Qt_fullScreen_fix = $_Qt_fullScreen_fix
Vue.prototype.$MathJax = $MathJax

/* eslint-disable no-new */
/* mount+render挂载，使用App挂载替换#app */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
